import { Inject, Injectable } from '@angular/core';
import { formatPath } from '@cawita/core-front';
import { CwtAssetConfig, CwtAssetDescriptor, CwtDocumentDescriptor, CWT_ASSET_CONFIG } from '@cawita/core-front/asset';
import { CwtAuthStoreService } from '@cawita/core-front/auth';
import { Document } from '../../models';

@Injectable()
export class KatchaAssetService {

    constructor(
        @Inject(CWT_ASSET_CONFIG) private config: CwtAssetConfig,
        private auth: CwtAuthStoreService) { }

    public getAssetUrl(asset: CwtAssetDescriptor | Document, isPrivate?: boolean, prefix?: string): string {
        if (!asset) return null;
        else if (typeof asset !== 'string' && !(asset as CwtDocumentDescriptor)?.path?.length && !(asset as Document).filePath?.length) return null;

        if (typeof asset === 'string' && asset.length) return this._relativePath(asset, prefix, isPrivate);

        const docPath = (asset as any)?.path ?? (asset as any)?.filePath;
        if (typeof asset !== 'string' && docPath?.length) return this._relativePath(docPath, prefix, (asset as any)?.isPrivate ?? isPrivate);
        return null;
    }

    private _relativePath(path: string, prefix?: string, isPrivate?: boolean) {
        /* If path starts with an http string, then path is absolute ! */
        if (path.startsWith('http')) { return path; }
        if (prefix?.length) {
            const fileSegments = path.split('/');
            const filePath = fileSegments[fileSegments?.length - 1];
            const folderPath = fileSegments.slice(0, fileSegments?.length - 1).join('/');

            path = formatPath(folderPath, prefix, filePath);
        }
        if (isPrivate && this.auth.assetToken?.length && this.config.protectedAssetPath?.length) return formatPath(this.config.apiUrl, this.config.protectedAssetPath, this.auth.assetToken, path);
        return formatPath(this.config.apiUrl, this.config.publicAssetPath, path);
    }
}
